import { render } from "./BranchSelectorMenu.vue?vue&type=template&id=2dbdfc00&scoped=true"
import script from "./BranchSelectorMenu.vue?vue&type=script&lang=js"
export * from "./BranchSelectorMenu.vue?vue&type=script&lang=js"

import "./BranchSelectorMenu.vue?vue&type=style&index=0&id=2dbdfc00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbdfc00"]])

export default __exports__